import { render, staticRenderFns } from "./RelatedFormsCustomGridItem.vue?vue&type=template&id=3b17851f&"
import script from "./RelatedFormsCustomGridItem.vue?vue&type=script&lang=js&"
export * from "./RelatedFormsCustomGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports